import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateOrEmDash',
})
export class DateOrEmDashPipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  transform(
    value: string | number | Date | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string,
  ): string {
    if (!value) {
      return '—';
    }
    return this.datePipe.transform(value, format, timezone, locale) || '—';
  }
}
